/**
 * IMPORT CORE DI ANGULAR
 */
import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MetaLoader, MetaStaticLoader, PageTitlePositioning } from '@ngx-meta/core';
import { environment } from '../environments/environment';
import { CustomTranslateLoader } from './shared/custom-translate-loader';
import { HammerGestureConfig } from '@angular/platform-browser';
var CustomHammerConfig = /** @class */ (function (_super) {
    tslib_1.__extends(CustomHammerConfig, _super);
    function CustomHammerConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CustomHammerConfig;
}(HammerGestureConfig));
export { CustomHammerConfig };
export function metaFactory(translate) {
    return new MetaStaticLoader({
        callback: function (key) {
            return key ? translate.get(key) : null;
        },
        pageTitlePositioning: PageTitlePositioning.PrependPageTitle,
        pageTitleSeparator: '',
        applicationName: '',
        defaults: {
            title: environment.appName,
            description: environment.appName
        }
    });
}
export function customLoaderFactory(http, platformId) {
    return new CustomTranslateLoader(http, platformId);
}
var ɵ0 = (customLoaderFactory), ɵ1 = (metaFactory);
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
